export const API_END_POINT = "https://6om9uz1co4.execute-api.ap-south-1.amazonaws.com/catharsisco-api";
//export const API_END_POINT: string = "https://6om9uz1co4.execute-api.ap-south-1.amazonaws.com/dev";
